// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getTeamStats} from 'mattermost-redux/actions/teams';

import MemberListTeam from './member_list_team.jsx';

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            getTeamStats
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberListTeam);



// WEBPACK FOOTER //
// ./components/member_list_team/index.js